import { __decorate } from "tslib";
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { OnboardingApi } from '@/api/onboarding/OnboardingApi';
import { AccountOnboarding } from '@/api/company/CompanyApi';
import { AccountApi } from '@/api/account/AccountApi';
import { BRANCH_KEY } from '@/helpers/consts';
import { safeSetItem } from '@/helpers/storage';
let OnboardingStore = class OnboardingStore extends VuexModule {
    branchData = null;
    categoryLocationSkillNames = [];
    appointmentCategoriesData = [];
    skills = [];
    companies = [];
    subAccounts = [];
    mutationBranchData(branchData) {
        this.branchData = branchData;
        safeSetItem(BRANCH_KEY, JSON.stringify(branchData));
    }
    setCategoryLocationSkillNames(category_location_skill_names) {
        this.categoryLocationSkillNames = category_location_skill_names;
    }
    setAppointmentCategoriesData(appointment_category_kinds) {
        this.appointmentCategoriesData = appointment_category_kinds;
    }
    async fetchCompanies() {
        const data = await AccountOnboarding.getAccountOnboardingCompanies({ page: 1, per_page: 50 });
        this.companies = data.companies;
    }
    setFetchSkills(skill_names) {
        this.skills = skill_names;
    }
    setSubAccountsData(sub_accounts) {
        this.subAccounts = sub_accounts;
    }
    async fetchCategoryLocationSkillNames() {
        const data = await OnboardingApi.categoryLocationSkillNames();
        return data.category_location_skill_names;
    }
    async fetchAppointmentCategoriesData() {
        const data = await OnboardingApi.getAppointmentCategoriesData();
        return data.appointment_category_kinds;
    }
    async fetchSubAccountsData() {
        return await AccountApi.fetchSubAccounts();
    }
    async fetchSkills() {
        const data = await OnboardingApi.fetchSkillNames();
        return data.skill_names;
    }
    get branchAddData() {
        return this.branchData;
    }
};
__decorate([
    Mutation
], OnboardingStore.prototype, "mutationBranchData", null);
__decorate([
    Mutation
], OnboardingStore.prototype, "setCategoryLocationSkillNames", null);
__decorate([
    Mutation
], OnboardingStore.prototype, "setAppointmentCategoriesData", null);
__decorate([
    Mutation
], OnboardingStore.prototype, "fetchCompanies", null);
__decorate([
    Mutation
], OnboardingStore.prototype, "setFetchSkills", null);
__decorate([
    Mutation
], OnboardingStore.prototype, "setSubAccountsData", null);
__decorate([
    Action({ commit: 'setCategoryLocationSkillNames' })
], OnboardingStore.prototype, "fetchCategoryLocationSkillNames", null);
__decorate([
    Action({ commit: 'setAppointmentCategoriesData' })
], OnboardingStore.prototype, "fetchAppointmentCategoriesData", null);
__decorate([
    Action({ commit: 'setSubAccountsData' })
], OnboardingStore.prototype, "fetchSubAccountsData", null);
__decorate([
    Action({ commit: 'setFetchSkills' })
], OnboardingStore.prototype, "fetchSkills", null);
OnboardingStore = __decorate([
    Module({ namespaced: true })
], OnboardingStore);
export default OnboardingStore;
